import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { TimeFormatService } from '../services/time-format.service';

@Pipe({
  name: 'customDate',
  standalone: true,
  pure: false, // Required since we depend on tenant settings that can change
})
export class CustomDatePipe implements PipeTransform {
  constructor(private timeFormatService: TimeFormatService) {}

  transform(value: Date | string, formatType: 'time' | 'dateTime' | 'shortDateTime' | 'date' = 'dateTime'): string {
    if (!value) return '';

    // Graceful fallback if tenant/settings aren't loaded yet
    if (!this.timeFormatService.isReady()) {
      // Fall back to default 12-hour format while loading
      const defaultFormats = {
        time: 'h:mm a',
        dateTime: 'MMM d yyyy h:mm a',
        shortDateTime: 'M/d/yyyy h:mm a',
        date: 'MMM d yyyy',
      };
      return moment(value).format(defaultFormats[formatType] || defaultFormats.dateTime);
    }

    const format = this.timeFormatService.getFormat(formatType);
    return moment(value).format(format);
  }
}
